module.exports = __webpack_public_path__ + "img/jqrjznzb_s.85d7b70.png";